import Vue from 'vue';
import fechas from '../libs/utils/fechas';
Vue.use(fechas);

import criterioDominios from '../libs/dominios/criteriosDominios';
Vue.use(criterioDominios);

import dominios from '../libs/dominios/dominios';
Vue.use(dominios);

import cadenas from '../libs/utils/cadenas';
Vue.use(cadenas);

import constantes from '../libs/utils/constantes';
Vue.use(constantes);

import validaciones from '../libs/utils/validaciones';
Vue.use(validaciones);

import estilos from '../libs/utils/estilos';
Vue.use(estilos);

import valoresHeader from '../libs/utils/getHeaderValue';
Vue.use(valoresHeader);

import libhashids from '../libs/utils/libHashids';
Vue.use(libhashids);

import enrutamiento from '../libs/utils/enrutamiento';
Vue.use(enrutamiento);





